import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, PrimaryBtn } from "@/components/site/shared";
import { useContent } from "@/lib/ContentContext";

export default function ServiceAreas() {
  const { content } = useContent();
  const [areas, setAreas] = useState([]);
  useEffect(() => { api.get("/service-areas").then((r) => setAreas(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader overline="Where We Work" title="Service Areas" />
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="flex flex-wrap justify-center gap-3">
            {areas.map((a) => (
              <div key={a.id} className="flex items-center gap-2 bg-[var(--navy)] text-white px-6 py-4 rounded-2xl">
                <MapPin className="w-5 h-5 text-[var(--aqua)]" />
                <span className="font-head font-bold text-xl uppercase">{a.name}, {a.state}</span>
                {a.primary && <span className="text-[10px] bg-[var(--red)] px-2 py-0.5 rounded-full">PRIMARY</span>}
              </div>
            ))}
          </div>
          <p className="text-[var(--text-muted)] mt-8 max-w-xl mx-auto">{content.service_area_note}</p>
          <div className="mt-8"><PrimaryBtn to="/get-a-quote">Check Availability — Get a Quote</PrimaryBtn></div>
        </div>
      </section>
    </div>
  );
}
